module.exports = __webpack_public_path__ + "img/Banner-Sijakon-Tukang.9af527c7.png";